import { change as changeFormValue, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import SeatMapContent from '../components/SeatMapContent';
import { SEATING_PREFERENCE_VALUES } from '../utils/constants';
import { getPrice, getSelected, processSeatSelection } from '../utils/seatMapContentContainerUtils';
export const mapStateToProps = (state, _ref) => {
  let {
    form
  } = _ref;
  const getSelectedFunction = getSelected('seatMap', form)(state);
  const {
    price,
    markup
  } = getPrice('seatMap', form)(state);
  const selectedSeatsWithValue = formValueSelector(form)(state, 'seatMap') || {};
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {
    value,
    ...selectedSeats
  } = selectedSeatsWithValue;
  const shouldShowConfirmationModal = form === 'traveler-details';
  return {
    getSelected: activeSegment => Object.values(getSelectedFunction(activeSegment)),
    totalMarkup: markup,
    totalPrice: price,
    selectedSeats,
    shouldShowConfirmationModal
  };
};
export const mapDispatchToProps = (dispatch, _ref2) => {
  let {
    form,
    setIsSeatMapModalOpen,
    travelers
  } = _ref2;
  return {
    onChange: (boundSegmentIndex, travelerId, carrier, column, row, seat, price, markup, seatPreference) => {
      const traveler = travelers.find(t => t.id === travelerId);
      const getSeatPreference = selectedSeatingPreference => ({
        seatPreference: selectedSeatingPreference !== null && selectedSeatingPreference !== void 0 ? selectedSeatingPreference : SEATING_PREFERENCE_VALUES.NO_OPTION
      });
      const segment = {
        ...traveler,
        carrier,
        column,
        price,
        row,
        value: seat,
        markup,
        id: travelerId,
        ...getSeatPreference(seatPreference)
      };
      dispatch(changeFormValue(form, 'seatMap.value.value', 'true'));
      dispatch(changeFormValue(form, `seatMap.${boundSegmentIndex}.traveler${travelerId}`, segment));
    },
    onClose: seatSelection => () => {
      const selectedSeats = processSeatSelection(seatSelection);
      if (selectedSeats.length === 0) {
        dispatch(changeFormValue(form, 'seatMap.value.value', 'false'));
      }
      setIsSeatMapModalOpen(false);
    },
    onRemove: (boundSegmentIndex, travelerId) => {
      dispatch(changeFormValue(form, `seatMap.${boundSegmentIndex}.traveler${travelerId}`, null));
    },
    onOptOut() {
      dispatch(changeFormValue(form, 'seatMap.value.value', 'false'));
      setIsSeatMapModalOpen(false);
    }
  };
};
export const SeatMapContentContainer = connect(mapStateToProps, mapDispatchToProps)(SeatMapContent);
export default SeatMapContentContainer;
//# sourceMappingURL=SeatMapContentContainer.js.map